import { useEffect, useState } from "react";

type SignedInState = "loading" | "yes" | "no";

export function useIsSignedInState(): SignedInState {
  const [state, setState] = useState<SignedInState>("loading");

  useEffect(() => {
    let cancelled = false;
    let unsubscribe: (() => void) | null = null;

    (async () => {
      const { supabase } = await import("@/integrations/supabase/client");

      const { data } = await supabase.auth.getSession();
      if (cancelled) return;
      setState(data.session ? "yes" : "no");

      const sub = supabase.auth.onAuthStateChange((_event, session) => {
        setState(session ? "yes" : "no");
      });
      unsubscribe = () => sub.data.subscription.unsubscribe();
    })();

    return () => {
      cancelled = true;
      if (unsubscribe) unsubscribe();
    };
  }, []);

  return state;
}

export function useIsSignedIn(): boolean {
  return useIsSignedInState() === "yes";
}
